export default import.meta.ROLLDOWN_FILE_URL_f8OVrQ$mjlwMx9kvqjUDuQ